import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/HomeScreen.gif'
import _imports_1 from '@/assets/images/Home.png'
import _imports_2 from '@/assets/images/Missions.png'
import _imports_3 from '@/assets/images/Stats.png'
import _imports_4 from '@/assets/images/Storage.png'
import _imports_5 from '@/assets/images/Vehicles.png'
import _imports_6 from '@/assets/images/Farms.png'
import _imports_7 from '@/assets/images/Calculator.png'


const _withScopeId = n => (_pushScopeId("data-v-1dc756b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "homeSection" }
const _hoisted_2 = {
  id: "liveSection",
  class: "sectionContainer"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_4 = {
  class: "sectionContent graphicLeft",
  style: {"opacity":"1"}
}
const _hoisted_5 = { class: "sectionText" }
const _hoisted_6 = { class: "sectionTitle" }
const _hoisted_7 = {
  id: "overviewSection",
  class: "sectionContainer"
}
const _hoisted_8 = { class: "sectionContent graphicRight" }
const _hoisted_9 = { class: "sectionText" }
const _hoisted_10 = { class: "sectionTitle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_12 = {
  id: "missionSection",
  class: "sectionContainer"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })
  ])
], -1))
const _hoisted_14 = {
  class: "sectionContent graphicLeft",
  style: {"opacity":"1"}
}
const _hoisted_15 = { class: "sectionText" }
const _hoisted_16 = { class: "sectionTitle" }
const _hoisted_17 = {
  id: "statsSection",
  class: "sectionContainer"
}
const _hoisted_18 = { class: "sectionContent graphicRight" }
const _hoisted_19 = { class: "sectionText" }
const _hoisted_20 = { class: "sectionTitle" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: ""
    })
  ])
], -1))
const _hoisted_22 = {
  id: "storageSection",
  class: "sectionContainer"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: ""
    })
  ])
], -1))
const _hoisted_24 = {
  class: "sectionContent graphicLeft",
  style: {"opacity":"1"}
}
const _hoisted_25 = { class: "sectionText" }
const _hoisted_26 = { class: "sectionTitle" }
const _hoisted_27 = {
  id: "vehicleSection",
  class: "sectionContainer"
}
const _hoisted_28 = { class: "sectionContent graphicRight" }
const _hoisted_29 = { class: "sectionText" }
const _hoisted_30 = { class: "sectionTitle" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    })
  ])
], -1))
const _hoisted_32 = {
  id: "farmsSection",
  class: "sectionContainer"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      alt: ""
    })
  ])
], -1))
const _hoisted_34 = {
  class: "sectionContent graphicLeft",
  style: {"opacity":"1"}
}
const _hoisted_35 = { class: "sectionText" }
const _hoisted_36 = { class: "sectionTitle" }
const _hoisted_37 = {
  id: "calculatorSection",
  class: "sectionContainer"
}
const _hoisted_38 = { class: "sectionContent graphicRight" }
const _hoisted_39 = { class: "sectionText" }
const _hoisted_40 = { class: "sectionTitle" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: ""
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("LiveUpdateTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("LiveUpdateText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("LiveUpdateSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("LiveUpdateSubtext")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("HomeTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("HomeText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("HomeSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("HomeSubtext")), 1)
        ])
      ]),
      _hoisted_11
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t("MissionsTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("MissionsText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("MissionsSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("MissionsSubtext")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.$t("StatsTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("StatsText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("StatsSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("StatsSubtext")), 1)
        ])
      ]),
      _hoisted_21
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.$t("StorageTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("StorageText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("StorageSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("StorageSubtext")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("h2", _hoisted_30, _toDisplayString(_ctx.$t("VehiclesTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("VehiclesText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("VehiclesSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("VehiclesSubtext")), 1)
        ])
      ]),
      _hoisted_31
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("h2", _hoisted_36, _toDisplayString(_ctx.$t("FarmsTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("FarmsText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("FarmsSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("FarmsSubtext")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("h2", _hoisted_40, _toDisplayString(_ctx.$t("CalculatorTitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("CalculatorText")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CalculatorSubtitle")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("CalculatorSubtext")), 1)
        ])
      ]),
      _hoisted_41
    ])
  ]))
}